import axios from 'axios';
import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import Loading from '../../components/loading/loading';
import {
  apiList,
  verifyLogin,
} from '../../helpers';
import Table from './table';
import SidePanel from '../../components/SidePanel/SidePanel';
import Form from './Form';

class ReportType extends Component {
  constructor() {
    super();
    this.state = {
      result: false,
      data: [],
      elemenntId: '',
      name: '',
      description: '',
      page: 0,
      rowsPerPage: 0,
      formOpen: false,
      newForm: true,
    };
  }

  componentDidMount() {
    this.getReportTypes();
  }

  handleShowAddForm(key, element) {
    key.preventDefault();
    this.toggleModal(true);
    if (element) {
      this.setState({
        name: element.name,
        elemenntId: element.id,
        description: element.description,
      });
    } else {
      this.setState({ name: '', elemenntId: '', description: '' });
    }
  }

  handleChange(key) {
    key.preventDefault();
    this.setState({ [key.target.id]: key.target.value });
  }

  handleSaveData() {
    const {
      elemenntId, name, description,
    } = this.state;
    if (name.length < 1 && description.length < 1) {
      toast.error('There is no change/modification found');
      return;
    }

    const { session } = verifyLogin();
    const config = { headers: { session } };
    const params = { name: name.trim(), description: description.trim() };
    if (elemenntId) {
      params.id = elemenntId;
    }
    axios.post(`${apiList.UPDATE_REPORT_TYPE}`, params, config)
      .then((response) => {
        toast.success(response.data.message);
        this.setState({
          name: '', elemenntId: '', description: '',
        });
        this.toggleModal(false);
        this.getReportTypes();
        setTimeout(() => {
          this.setState({ result: false });
        }, 1000);
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);

        setTimeout(() => {
          this.setState({ result: false });
        }, 1000);
      });
  }

  getReportTypes() {
    this.setState({ result: true });
    const { session } = verifyLogin();
    const config = { headers: { session } };

    axios.get(`${apiList.GET_REPORT_TYPE}`, config)
      .then((response) => {
        this.setState({ data: [...response.data.data] });
        setTimeout(() => {
          this.setState({ result: false });
        }, 1000);
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);

        setTimeout(() => {
          this.setState({ result: false });
        }, 1000);
      });
  }

  body=() => (
    <Form
      handleChange={(id) => this.handleChange(id)}
      name={this.state.name}
      elemenntId={this.state.elemenntId}
      description={this.state.description}
    />
  )

  toggleModal(value) {
    this.setState({ formOpen: value });
  }

  render() {
    const {
      result,
      formOpen,
      data,
      page,
      rowsPerPage,
      newForm,
    } = this.state;

    verifyLogin();
    return (
      <div className='users'>

        <ToastContainer />

        {result === true ? <Loading MainProps={this.props} /> : null }

        {result === false && (
        <Table
          data={Array.isArray(data) ? data : []}
          MainProps={this.props}
          handleDeleteData={(key, id) => this.handleDeleteData(key, id)}
          handleShowEditForm={(key, element) => this.handleShowAddForm(key, element)}
          handleShowAddForm={(key) => this.handleShowAddForm(key)}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={(event, newPage) => this.handleChangePage(event, newPage)}
          handleChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event)}
        />
        )}

        <SidePanel
          open={formOpen}
          setOpen={(value) => this.toggleModal(value)}
          newForm={newForm}
          body={this.body()}
          handleSaveData={() => this.handleSaveData()}
          title={newForm ? 'Add Report Type' : 'Update Report Type'}
        />

      </div>
    );
  }
}

export default ReportType;
